import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import Avatar from '../../atoms/Avatar';
import Content from '../../atoms/Content';
import Ellipsis from '../../atoms/Ellipsis';
import styles from './userInfo.module.scss';
var UserInfoCompact = function UserInfoCompact(_ref) {
  var image = _ref.image,
    userName = _ref.userName,
    length = _ref.length,
    contentClassName = _ref.contentClassName;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Avatar, {
    className: "".concat(styles.avatar, " inline-block"),
    name: userName,
    displayName: false,
    image: image,
    size: "small"
  }), /*#__PURE__*/React.createElement(Content, {
    className: contentClassName,
    highlight: true
  }, /*#__PURE__*/React.createElement(Ellipsis, {
    length: length,
    tooltip: true
  }, userName)));
};
UserInfoCompact.propTypes = {
  image: PropTypes.string,
  length: PropTypes.number,
  userName: PropTypes.string.isRequired,
  contentClassName: PropTypes.string
};
UserInfoCompact.defaultProps = {
  image: EMPTY_STRING,
  contentClassName: EMPTY_STRING,
  length: 10
};
export default UserInfoCompact;